type State = {
	idVeiculoTipo: number;
	idVeiculoMarca: number;
	idVeiculoModelo: number;
	ano: string;
	combustivel: string;
	codigoFipe: string;
	valorFipe: string;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number };

export const newYearFormInitialState: State = {
	idVeiculoTipo: 0,
	idVeiculoMarca: 0,
	idVeiculoModelo: 0,
	ano: '',
	combustivel: '',
	codigoFipe: '',
	valorFipe: '',
};

export const newYearFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				[action.field]: action.payload,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		default:
			return state;
	}
};
